import BrandSelector from "@components/plasmic/custom-options/category-selector/brand-selector";

import { CE_05, DEFAULT } from "@helpers/plasmic/slices";

import { BRAND_VISIBLE_BRAND_COUNT } from "@constants/plasmic/slices";

export const CE_05_SliceProps = {
  visibleBrandCount: {
    type: "number",
    hidden: (props) => props.variant !== CE_05,
    defaultValue: BRAND_VISIBLE_BRAND_COUNT,
  },
  hideCategorySelector: {
    type: "boolean",
    defaultValue: false,
    hidden: (props) => props.variant !== CE_05,
  },
  customBrands: {
    type: "array",
    description: "Brands to display in the catalog entries.",
    itemType: {
      type: "object",
      nameFunc: (item) => item?.name || "Brand",
      fields: {
        name: { type: "string" },
        logo: { type: "imageUrl" },
        key: {
          type: "custom",
          control: BrandSelector,
          description: "Selected brand will be treated as the root brand for the catalog entries",
        },
      },
    },
    hidden: (props) => props.viewType === DEFAULT || props.variant !== CE_05,
  },
};
